import { Cast, CastType, IDataModel, Model } from '@klickdata/core/application';
import { AppScope } from '@klickdata/core/resource';

export interface CustomFieldOption {
    id?: number;
    value?: Record<string, string>[];
}

export interface CustomFieldData extends IDataModel {
    id?: number;
    name?: any;
    placeholder?: any;
    type?: string;
    options?: any;
    default?: boolean;
    scope_id?: AppScope;
    customer_id?: number;
    order?: number;
    enabled?: boolean;
    disabled?: boolean;
    editable?: boolean;
    value?: any;
    initial_value?: any;
}

export class CustomField extends Model<CustomFieldData> {
    id: number;
    name: any;
    placeholder: any;
    type: string;
    options: any;
    default: boolean;
    scope_id: AppScope;
    customer_id: number;
    @Cast(CastType.CLOSURE, (order: string | number) => +order)
    order: number;
    enabled: boolean;
    disabled: boolean;
    editable: boolean;
    value: any;
    initial_value: any;
    key?: string;
}
export enum FieldType {
    TEXT_INPUT = 'input',
    SINGLE_CHOICE = 'radio',
    MULTIPLE_CHOICE = 'checkbox',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    SWITCH = 'switch',
    FILE = 'file',
}
